import {takeEvery} from 'redux-saga/effects';
import createAsyncSaga from 'lib/createAsyncSaga';
import {setWebEditor} from 'lib/api/setWebEditorJob';
import {
  setWebEditorJobAction,
  SAVE_POST,
} from 'modules/setWebEditorJob/actions';

const setWebEditorJobSaga = createAsyncSaga(
  setWebEditorJobAction,
  setWebEditor,
);

export function* SaveWebEditorJobSaga() {
  yield takeEvery(SAVE_POST, setWebEditorJobSaga);
}
